import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.showDialog,
    width: "auto",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          (_ctx.icon !== undefined)
            ? (_openBlock(), _createBlock(_component_v_card_item, {
                key: 0,
                class: "mx-auto"
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    icon: _ctx.icon,
                    color: "pca-blue",
                    size: "large"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card_text, {
            class: "secondary-font pca-blue text-center pb-0",
            style: {"font-size":"14px","font-weight":"600"},
            innerHTML: _ctx.message
          }, null, 8, ["innerHTML"]),
          (_ctx.caption)
            ? (_openBlock(), _createBlock(_component_v_card_text, {
                key: 1,
                class: "secondary-font pca-blue text-center pb-0",
                style: {"font-size":"14px","font-weight":"600"},
                innerHTML: _ctx.caption
              }, null, 8, ["innerHTML"]))
            : _createCommentVNode("", true),
          (!_ctx.confirmBtnOnly)
            ? (_openBlock(), _createBlock(_component_v_card_actions, {
                key: 2,
                class: _normalizeClass(["d-flex pa-6", { 'justify-space-between': !_ctx.hideDeclineBtn, 'justify-center': _ctx.hideDeclineBtn }])
              }, {
                default: _withCtx(() => [
                  (!_ctx.hideDeclineBtn)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        class: _normalizeClass([_ctx.declineBtnColorClass, "form-btn"]),
                        onClick: _ctx.handleDecline
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.declineLabel), 1)
                        ]),
                        _: 1
                      }, 8, ["class", "onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_btn, {
                    class: _normalizeClass([_ctx.confirmBtnColorClass, "form-btn"]),
                    onClick: _ctx.handleConfirm
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.confirmLabel), 1)
                    ]),
                    _: 1
                  }, 8, ["class", "onClick"])
                ]),
                _: 1
              }, 8, ["class"]))
            : (_openBlock(), _createBlock(_component_v_card_actions, {
                key: 3,
                class: "d-flex justify-center pa-6",
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: _normalizeClass([_ctx.confirmBtnColorClass, "form-btn"]),
                    onClick: _ctx.handleConfirm
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.confirmLabel), 1)
                    ]),
                    _: 1
                  }, 8, ["class", "onClick"])
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}